import MuiDialogActions from '@material-ui/core/DialogActions';

export default MuiDialogActions;
